import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/root-reducer';
import { OnBehalfOfOrganizationState } from './types';

const initialState: OnBehalfOfOrganizationState = {
  onBehalfOfOrganization: undefined,
};

const onBehalfOfOrganizationSlice = createSlice({
  name: 'jobSeekerOnBehalfOfOrganization',
  initialState,
  reducers: {
    setOnBehalfOfOrganization: (state, action) => {
      state.onBehalfOfOrganization = action.payload;
    },
    clearOnBehalfOfOrganization: (state) => {
      state.onBehalfOfOrganization = undefined;
    },
  },
});

export const selectJobSeekerOnBehalfOfOrganization = (state: RootState) => state.jobSeekerOnBehalfOfOrganization.onBehalfOfOrganization;
export const selectJobSeekerOnBehalfOfOrganizationId = (state: RootState) => state.jobSeekerOnBehalfOfOrganization.onBehalfOfOrganization?.value;

export const { setOnBehalfOfOrganization, clearOnBehalfOfOrganization } = onBehalfOfOrganizationSlice.actions;
export const jobSeekerOnBehalfOfOrganizationReducer = onBehalfOfOrganizationSlice.reducer;
